import { TabsProps } from 'antd';
import { Tabs } from '@/shared/ui';
import { InvitationsTab } from './InvitationsTab';
import { MembersTab } from './MembersTab';
import { WorkspaceProcsTab } from './WorkspaceProcsTab';

enum TabsType {
  Procs = 'procs',
  Members = 'members',
  Invitations = 'invitations',
}

const items: TabsProps['items'] = [
  {
    key: TabsType.Procs,
    label: `Procs`,
    children: <WorkspaceProcsTab />,
  },
  {
    key: TabsType.Members,
    label: `Members`,
    children: <MembersTab />,
  },
  {
    key: TabsType.Invitations,
    label: `Invitations`,
    children: <InvitationsTab />,
  },
];

export const WorkspaceTabs = () => {
  return <Tabs data-testid="home-workspace-tabs" items={items} />;
};
